import fallbackPieces from 'chessboard/renderers/default/assets/default-pieces-base64.json';
import fallbackBoard from 'chessboard/renderers/default/assets/default-board-base64.json';
import { ThemeAssets } from 'chessboard/config/theme-assets';
import { pieceShortNames } from 'chessboard/config/theme-constants';
import { defaultLegacyPieceStyles } from 'chessboard/config/legacy-themes';
import { getLegacyPieceBaseURL } from 'chessboard/model/board/get-legacy-piece-base-url';
import type { Board } from 'chessboard/model/board/types';
import { defaultThemeAssets } from 'config/default-theme-assets';

/**
 * Returns a new themeAssets object using default assets
 */
export function transformThemeToDefaultAssets(
  themeAssets: ThemeAssets.Assets,
): ThemeAssets.Assets2D {
  return {
    ...themeAssets,
    board: {
      assets: {
        background: fallbackBoard.board,
      },
      config: {
        highlightSquareHex: defaultThemeAssets.board.config.highlightSquareHex,
        lightSquareCoordinateHex: defaultThemeAssets.board.config.lightSquareCoordinateHex,
        darkSquareCoordinateHex: defaultThemeAssets.board.config.darkSquareCoordinateHex,
      },
    },
    pieces: {
      assets: fallbackPieces,
    },
    config: {
      perspective: ThemeAssets.Perspective.TOP_DOWN,
    },
  };
}

/**
 * builds piece assets for themeAssets option from legacy piece style string
 */
export function buildPieceAssetsFromLegacyPieceStyle(
  pieceStyle: string,
  size = 150,
  options?: Board.Options,
): ThemeAssets.PieceAssets2D {
  const legacyPieceStyleConfig = defaultLegacyPieceStyles[pieceStyle];
  if (!legacyPieceStyleConfig) {
    throw new Error(`unknown piece style: ${pieceStyle}`);
  }

  return pieceShortNames.reduce((acc, pieceName) => {
    acc[pieceName] =
      `${getLegacyPieceBaseURL(legacyPieceStyleConfig.path, size, options)}/${pieceName}.${legacyPieceStyleConfig.format}`;
    return acc;
  }, {} as ThemeAssets.PieceAssets2D);
}
